import { render, staticRenderFns } from "./uploadeindex.vue?vue&type=template&id=63649efe"
import script from "./uploadeindex.vue?vue&type=script&lang=js"
export * from "./uploadeindex.vue?vue&type=script&lang=js"
import style0 from "./uploadeindex.vue?vue&type=style&index=0&id=63649efe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports